import { render, staticRenderFns } from "./ReservoirPassport.vue?vue&type=template&id=344578e4&scoped=true"
import script from "./ReservoirPassport.vue?vue&type=script&lang=js"
export * from "./ReservoirPassport.vue?vue&type=script&lang=js"
import style0 from "./ReservoirPassport.vue?vue&type=style&index=0&id=344578e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344578e4",
  null
  
)

export default component.exports